import "../css/table.css";
import "../css/individualUser.css";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  LOAD_ALLUSER_REQUEST,
  LOAD_INDIVIDUAL_REQUEST,
} from "../reducers/adminUser";

const IndividualUser = ({ onSelectDetail }) => {
  const dispatch = useDispatch();
  const { allUsers, userIndividuals } = useSelector((state) => state.adminUser);
  // 이 화면은 회원 데이터를 쓰면서도 정작 불러오라는 요청을 하지 않고 있었습니다.
  // "전체회원" 메뉴를 먼저 들르지 않으면 목록이 통째로 비어 보였습니다.
  useEffect(() => {
    dispatch({ type: LOAD_ALLUSER_REQUEST });
    dispatch({ type: LOAD_INDIVIDUAL_REQUEST });
  }, []);

  // 생년월일이 비어있는 회원이 있으면 예전 코드는 여기서 에러가 났습니다.
  const age = (num) => {
    if (!num || num.length < 4) return "-";
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentAge = currentYear - parseInt(num.substring(0, 4), 10) + 1;
    if (Number.isNaN(currentAge)) return "-";
    return currentAge;
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const handleModal = (data) => {
    setModalData(data);
    setModalOpen(true);
  };
  return (
    <div className="section individualUser">
      <div className="table_container">
        <div className="row row_head">
          <p>No</p>
          <p>이름</p>
          <p>주소</p>
          <p>경력</p>
          <p>근무형태</p>
          <p>나이</p>
        </div>
        {userIndividuals &&
          allUsers &&
          userIndividuals.map((userIndividual, index) => {
            // 주소가 아직 등록되지 않은 구직자가 하나라도 있으면 예전 코드는
            // 여기서 멈춰버려 목록 전체가 안 나왔습니다.
            const array = userIndividual.user_member_jibunAddress
              ? userIndividual.user_member_jibunAddress.split(" ")
              : [];
            const userDetail = allUsers.find(
              (user) => user.id === userIndividual.IndividualId
            );
            const individualId = userIndividual.IndividualId;
            const previousComponent = "구직자";
            return (
              <div
                className={
                  index % 2 === 0 ? "content_row row" : "content_row row even"
                }
                key={index}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  onSelectDetail("구직자 정보 상세", {
                    userIndividual,
                    userDetail,
                  });
                }}
              >
                <p>{userIndividual.id}</p>
                <p>{userIndividual.user_member_name}</p>
                <p>{array.slice(0, 3).join(" ")}</p>
                <p>{`${Math.floor(userIndividual.user_member_career / 12)}년 ${
                  userIndividual.user_member_career % 12
                }개월`}</p>
                <p>{userIndividual.user_member_workType}</p>
                <p>{age(userIndividual.user_member_num)}세</p>
                <p
                  className="btn"
                  onClick={(e) =>
                    e.stopPropagation() ||
                    onSelectDetail("이력서", {
                      individualId,
                      previousComponent,
                    })
                  }
                >
                  이력서
                </p>
                <p
                  className="btn"
                  onClick={(e) =>
                    e.stopPropagation() ||
                    onSelectDetail("경력사항", {
                      individualId,
                    })
                  }
                >
                  경력사항
                </p>
                <p
                  className="btn"
                  onClick={(e) => {
                    e.stopPropagation() || handleModal(userIndividual);
                  }}
                >
                  연락처
                </p>
              </div>
            );
          })}
      </div>
      {modalOpen && modalData && (
        <div className="modal">
          <p>이름 : {modalData.user_member_name}</p>
          <p>연락처 : {modalData.user_member_tel}</p>
          <p>이메일 : {modalData.user_member_email}</p>
          <button
            onClick={() => {
              setModalOpen(false);
            }}
          >
            확인
          </button>
        </div>
      )}
    </div>
  );
};

export default IndividualUser;
